// src/pages/ServiceDetailPage.jsx
import { useParams, Navigate } from 'react-router-dom';
import { servicesData } from '../data/services';
import { DetailPageTemplate } from '../components/templates/DetailPageTemplate';
import { Seo } from '../components/Seo';
import { serviceJsonLd, breadcrumbJsonLd } from '../lib/structuredData';

export function ServiceDetailPage() {
  const { slug } = useParams();
  const service = servicesData.find((s) => s.slug === slug);

  if (!service) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <Seo
        title={`${service.cat} 서비스 — medilawyer`}
        description={service.desc}
        path={`/services/${service.slug}`}
        jsonLd={[
          serviceJsonLd({
            name: service.cat,
            description: service.desc,
            path: `/services/${service.slug}`,
          }),
          breadcrumbJsonLd([
            { name: '홈', path: '/' },
            { name: '서비스', path: '/#services' },
            { name: service.cat, path: `/services/${service.slug}` },
          ]),
        ]}
      />
      <DetailPageTemplate
        eyebrow={service.cat}
        title={service.title.replace(/\n/g, ' ')}
        intro={service.detailIntro}
        hero={{ img: service.img, alt: service.imgAlt }}
        sections={service.detailSections}
        ctaLabel={service.ctaLabel}
        serviceContext={`service:${service.slug}`}
        backHref="/#services"
      />
    </>
  );
}
